import React from 'react';
import cx from 'classnames';

import IconButton from '../IconButton';
import Reset from '../Icons/Reset';

import FilterItem, { FilterItemProps } from './FilterItem';

import styles from './FilterGroup.module.scss';
export interface FilterComposition {
  Group: React.FC<Props>;
  Item: React.FC<FilterItemProps>;
}
export interface Props {
  /** Children of `Filter.Group` which should be one or more `Filter.Item`. */
  children:
    | React.ReactElement<FilterItemProps>
    | React.ReactElement<FilterItemProps>[];
  /** Apply CSS className for `Filter` container. */
  className?: Parameters<typeof cx>[0];
  /** Accessible name for the `Filter.Group`, which will be visually hidden by default. */
  label: string;
  /** Function that will be called when the `Filter` values get reset to initial values. */
  onReset?: () => void;
}

export const Filter: React.FC<Props> & FilterComposition = ({
  children,
  className,
  label,
  onReset,
}) => {
  return (
    <div className={cx(styles.filterGroup, className)}>
      <div className='visually-hidden'>{label}</div>
      {children}
      <div>
        <IconButton
          accessibilityLabel='Reset All Filters'
          icon={<Reset />}
          onClick={() => {
            onReset !== undefined && onReset();
          }}
        />
      </div>
    </div>
  );
};

Filter.displayName = 'Filter';

Filter.Group = Filter;
Filter.Item = FilterItem;

export default Filter;
export { styles };
